import {React, styled} from 'common'
import {Texts} from 'appearance'
import {useI18n} from 'store/Store'
import {useNavigate} from 'react-router-dom'
import Dialog from 'components/Display/Dialog/Dialog'

const MaxQuotaDialog = ({quotaError, setQoutaError}) => {
    const navigate = useNavigate()
    const {i18n} = useI18n()
    return (
        <Dialog
            fullWidth
            maxWidth="lg"
            title={i18n.t('maxQuotaDialog.title')}
            saveButtonText={i18n.t('maxQuotaDialog.button')}
            open={quotaError}
            handleClose={() => setQoutaError(null)}
            showCancel={true}
            handleSave={() =>
                navigate('/settings', {state: {paymentMethods: true}})
            }>
            <Description>{quotaError}</Description>
        </Dialog>
    )
}

export default MaxQuotaDialog

const Description = styled(Texts.RegularText)``
